// removed by extract-text-webpack-plugin
module.exports = {"teamMatchupCell":"teamPRM__teamMatchupCell--3IIYL","teamlogo":"teamPRM__teamlogo--3IMop","wrapper":"teamPRM__wrapper--6ubAL","teamRankingsTable":"teamPRM__teamRankingsTable--2Y0mp"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/TeamPositionRanksMatchups/teamPRM.css
// module id = +D/p
// module chunks = 37